const isAuthenticated = () => {
  const auht = localStorage.getItem('Authorization');
  if (auht) {
    return true;
  }
  return false;
};

export default isAuthenticated;
